import React from 'react';
import { Star, Quote } from 'lucide-react';
import { testimonials } from '../data/mock';
import './Reviews.css';

export const Reviews = () => {
  return (
    <section id="reviews" className="reviews section">
      <div className="container">
        <div className="reviews-header">
          <h2 className="section-title">
            Client <span className="gradient-text">Reviews</span>
          </h2>
          <p className="section-subtitle">
            What our clients say about working with us
          </p>
        </div>

        <div className="reviews-grid">
          {testimonials.map((review, index) => (
            <div
              key={review.id}
              className="review-card"
              style={{ animationDelay: `${index * 0.15}s` }}
            >
              <div className="review-quote-icon">
                <Quote size={32} />
              </div>
              
              <div className="review-stars">
                {[...Array(review.rating)].map((_, i) => (
                  <Star key={i} size={18} fill="currentColor" />
                ))}
              </div>

              <p className="review-content">{review.content}</p>

              <div className="review-author">
                <img
                  src={review.image}
                  alt={review.name}
                  className="review-author-image"
                  loading="lazy"
                />
                <div className="review-author-info">
                  <div className="review-author-name">{review.name}</div>
                  <div className="review-author-role">{review.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
